"use strict";

document.getElementById("language").addEventListener("change", function () {
    var selectedLang = this.value;
    var baseUrl = window.location.origin + "/projetsPersonnel/Moelleux_au_Chocolat/";
    window.location.href = baseUrl + selectedLang + "/index.html";
});

const fileName = window.location.pathname.split("/").pop();

var menuBtn = document.querySelector(".menu__btn");
var menuElements = document.querySelectorAll(".menu__li");

menuBtn.addEventListener("click", toggleMenu);
menuElements.forEach((element) => {
    element.addEventListener("click", toggleMenu);
});

function toggleMenu() {
    var menu = document.querySelector(".menu");
    menu.classList.toggle("menu--open");
};

const btt = document.getElementById("btt");

window.addEventListener("scroll", () => {
    btt.classList.toggle("visible", window.scrollY > 400);
});

/*
if (fileName === "covers.html") {
    const apiKey = 'AIzaSyArL2dv8ObQpQRyUDpYfQuDLbJnPDTq0Yc';
    const channelId = 'UC1vaJkbuGCbRU4OWJ3eCZ4A';

    /*let nextPageToken = '';*//*
    const container = document.getElementById('videos');*/
    /*const loadMoreBtn = document.getElementById('loadMore');
    const loadLessBtn = document.getElementById('loadLess');*/

    /*async function fetchVideos() {
        const url = `https://www.googleapis.com/youtube/v3/search?key=${apiKey}&channelId=${channelId}&part=snippet,id&order=date&maxResults=8&pageToken=${nextPageToken}`;
        const response = await fetch(url);
        const data = await response.json();

        const videoIds = data.items
            .filter(item => item.id.kind === 'youtube#video')
            .map(item => item.id.videoId)
            .join(',');


        // Deuxième appel pour récupérer les durées
        const detailsUrl = `https://www.googleapis.com/youtube/v3/videos?key=${apiKey}&id=${videoIds}&part=contentDetails`;
        const detailsResponse = await fetch(detailsUrl);
        const detailsData = await detailsResponse.json();

        detailsData.items.forEach(video => {
            const duration = video.contentDetails.duration;
            const seconds = parseISODuration(duration);
            if (seconds >= 50) {
                const videoId = video.id;
                const snippet = data.items.find(item => item.id.videoId === videoId)?.snippet;

                const videoWrapper = document.createElement('div');
                videoWrapper.style.display = 'flex';
                videoWrapper.style.alignItems = 'start';
                videoWrapper.style.justifyContent = 'center';
                videoWrapper.style.marginBottom = '50px';
                videoWrapper.style.gap = '30px';

                const iframe = document.createElement('iframe');
                iframe.width = '400';
                iframe.height = '225';
                iframe.src = `https://www.youtube.com/embed/${videoId}`;
                iframe.allowFullscreen = true;

                const desc = document.createElement('div');
                desc.style.maxWidth = '400px';
                const description = decodeHTML(snippet?.title || 'Pas de description');
                desc.textContent = description;


                videoWrapper.appendChild(iframe);
                videoWrapper.appendChild(desc);
                container.appendChild(videoWrapper);
            }
        });

        function decodeHTML(html) {
            const txt = document.createElement('textarea');
            txt.innerHTML = html;
            return txt.value;
        }*/

        /*
        nextPageToken = data.nextPageToken || '';
        if (!nextPageToken) {
            loadMoreBtn.style.display = 'none';
            loadLessBtn.style.display = 'block';
        } else {
            loadMoreBtn.style.display = 'block';
            loadLessBtn.style.display = 'none';
        }*//*
    }

    // Fonction pour convertir la durée ISO 8601 en secondes
    function parseISODuration(iso) {
    const match = iso.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
    const hours = parseInt(match[1] || '0', 10);
    const minutes = parseInt(match[2] || '0', 10);
    const seconds = parseInt(match[3] || '0', 10);
    return hours * 3600 + minutes * 60 + seconds;
    }

    // Écouter le clic sur le bouton "loadLess"
    loadLessBtn.addEventListener('click', () => {
        const iframes = container.querySelectorAll('iframe');

        // Supprimer les iframes à partir du 7e (index 6 et au-delà)
        for (let i = 6; i < iframes.length; i++) {
            container.removeChild(iframes[i]);
        }

        nextPageToken = ''; // Si tu veux recharger depuis le début
        loadMoreBtn.style.display = 'block';
        loadLessBtn.style.display = 'none';
    });

    loadMoreBtn.addEventListener('click', fetchVideos);

    // Charger la première page automatiquement
    fetchVideos();
};*/

if (fileName === "covers.html") {
    const apiKey = 'AIzaSyArL2dv8ObQpQRyUDpYfQuDLbJnPDTq0Yc';
    const channelId = 'UC1vaJkbuGCbRU4OWJ3eCZ4A';
    const container = document.getElementById('videos');

    async function fetchTopVideos() {
        // 1. Récupérer jusqu'à 50 vidéos
        const searchUrl = `https://www.googleapis.com/youtube/v3/search?key=${apiKey}&channelId=${channelId}&part=snippet,id&order=date&type=video&maxResults=50`;
        const searchResp = await fetch(searchUrl);
        const searchData = await searchResp.json();

        const videoIds = searchData.items
            .map(item => item.id.videoId)
            .filter(Boolean)
            .join(',');

        // 2. Obtenir les statistiques (vues + durée)
        const statsUrl = `https://www.googleapis.com/youtube/v3/videos?key=${apiKey}&id=${videoIds}&part=statistics,contentDetails,snippet`;
        const statsResp = await fetch(statsUrl);
        const statsData = await statsResp.json();

        // 3. Trier par nombre de vues
        const sortedVideos = statsData.items
            .map(video => {
                return {
                    id: video.id,
                    title: video.snippet.title,
                    views: parseInt(video.statistics.viewCount || '0'),
                    duration: video.contentDetails.duration
                };
            })
            .filter(v => parseISODuration(v.duration) >= 50)
            .sort((a, b) => b.views - a.views)
            .slice(0, 6);

        // 4. Affichage dans le HTML
        sortedVideos.forEach(video => {
            const videoWrapper = document.createElement('div');
            videoWrapper.style.display = 'flex';
            videoWrapper.style.alignItems = 'start';
            videoWrapper.style.justifyContent = 'center';
            videoWrapper.style.marginBottom = '50px';
            videoWrapper.style.gap = '30px';

            const iframe = document.createElement('iframe');
            iframe.width = '400';
            iframe.height = '225';
            iframe.src = `https://www.youtube.com/embed/${video.id}`;
            iframe.allowFullscreen = true;

            const desc = document.createElement('div');
            desc.style.maxWidth = '400px';
            desc.textContent = video.title;

            videoWrapper.appendChild(iframe);
            videoWrapper.appendChild(desc);
            container.appendChild(videoWrapper);
        });
    }

    function parseISODuration(iso) {
        const match = iso.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
        const hours = parseInt(match[1] || '0', 10);
        const minutes = parseInt(match[2] || '0', 10);
        const seconds = parseInt(match[3] || '0', 10);
        return hours * 3600 + minutes * 60 + seconds;
    }

    // Charger automatiquement au démarrage
    fetchTopVideos();
}
